"use client";
import { jsx as o } from "react/jsx-runtime";
import { memo as n, forwardRef as c } from "react";
import { useSvgIcon as i } from "../useSvgIcon.js";
const m = n(
  c((r, e) => {
    const t = i({
      ...r,
      ref: e
    });
    return /* @__PURE__ */ o(
      "svg",
      {
        width: 24,
        height: 24,
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...t(),
        children: /* @__PURE__ */ o(
          "path",
          {
            d: "M23 7C23 7 19.8729 7 19 7C17.9229 7 18 6.89036 18 8C18 8.9247 18 11 18 11H23L22 16H18V30H12V16H9V11H12C12 11 12 10.0885 12 7C12 3.46764 13.8029 2 18 2C18.6871 2 23 2 23 2V7Z",
            fill: "var(--icon-color)"
          }
        )
      }
    );
  })
);
m.displayName = "IconFacebook";
export {
  m as IconFacebook
};
